import { useState } from 'react';

export default function Footer() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Add form submission logic here
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <footer className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
      {/* Constellation pattern background */}
      <div className="absolute inset-0 opacity-20">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animation: `twinkle ${2 + Math.random() * 3}s infinite ${Math.random() * 2}s`
            }}
          ></div>
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-20 py-20">
        <div className="flex gap-20 mb-16">
          {/* Left 40%: Company info */}
          <div className="w-2/5">
            <div className="text-4xl font-bold mb-8">ONSQUARE INC.</div>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-blue-400 mt-1"></i>
                <div>
                  <div className="font-medium">Location</div>
                  <div className="text-sm text-slate-400">202-B047, 50 Myeongji Ocean City 9-ro, Gangseo-gu, Busan, Republic of Korea</div>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <i className="ri-file-text-line text-xl text-blue-400 mt-1"></i>
                <div>
                  <div className="font-medium">Business Registration</div>
                  <div className="text-sm text-slate-400">Venture Certified Company</div>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <i className="ri-user-line text-xl text-blue-400 mt-1"></i>
                <div>
                  <div className="font-medium">CEO</div>
                  <div className="text-sm text-slate-400">CHAEHYUN LIM</div>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-xl text-blue-400 mt-1"></i>
                <div>
                  <div className="font-medium">Email</div>
                  <div className="text-sm text-slate-400">info@dearfriday.net</div>
                </div>
              </div>
            </div>

            {/* Social icons */}
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full hover:bg-blue-500 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-linkedin-fill text-xl group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="#" 
                className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full hover:bg-blue-400 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-twitter-x-line text-xl group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="#" 
                className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full hover:bg-slate-600 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-medium-fill text-xl group-hover:scale-110 transition-transform"></i>
              </a>
            </div>
          </div>

          {/* Right 60%: Contact form with frosted glass effect */}
          <div className="w-3/5">
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold mb-6">Send us a Message</h3>
              
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <div className="relative">
                    <i className="ri-user-line absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400"></i>
                    <input
                      type="text"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="w-full bg-white/10 border border-white/30 rounded-xl pl-12 pr-4 py-3 text-white placeholder-slate-400 focus:outline-none focus:border-blue-400 transition-colors"
                      required
                    />
                  </div>
                </div>

                <div>
                  <div className="relative">
                    <i className="ri-mail-line absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400"></i>
                    <input
                      type="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full bg-white/10 border border-white/30 rounded-xl pl-12 pr-4 py-3 text-white placeholder-slate-400 focus:outline-none focus:border-blue-400 transition-colors"
                      required
                    />
                  </div>
                </div>

                <div>
                  <div className="relative">
                    <i className="ri-message-3-line absolute left-4 top-4 text-slate-400"></i>
                    <textarea
                      placeholder="Your Message"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      rows={4}
                      className="w-full bg-white/10 border border-white/30 rounded-xl pl-12 pr-4 py-3 text-white placeholder-slate-400 focus:outline-none focus:border-blue-400 transition-colors resize-none"
                      required
                    ></textarea>
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3 rounded-xl font-medium hover:from-blue-600 hover:to-blue-700 transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
                >
                  Send Message
                  <i className="ri-send-plane-fill"></i>
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Bottom: Copyright and links */}
        <div className="border-t border-white/10 pt-8 flex items-center justify-between">
          <div className="text-sm text-slate-400">
            © 2024 ONSQUARE INC. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors hover:underline cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors hover:underline cursor-pointer">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors hover:underline cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
